import { FiChevronRight } from "react-icons/fi";
import { MdWarning, MdErrorOutline, MdNotifications } from "react-icons/md";

export function renderAlert () {
    return (
  <div className="transition-opacity duration-300">

    {/* Breadcrumb */}
    <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
      <a className="hover:text-primary hover:underline" href="#">Netraa APM</a>
      <FiChevronRight className="text-[14px]" />
      <span>Product Capabilities</span>
      <FiChevronRight className="text-[14px]" />
      <span className="text-[#1b140d] dark:text-white font-medium">Alerting Module</span>
    </nav>

    {/* HEADER */}
    <div className="mb-12">
      <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#1b140d] dark:text-white mb-6 leading-[1.15]">
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
          Alerting Module:
        </span> <br />
        Proactive Detection & Operational Control
      </h1>
      <p className="text-lg md:text-xl text-[#4b5563] dark:text-gray-300 leading-relaxed">
        The Alerting Module in Netraa APM is designed to move teams away from reactive firefighting toward proactive operational control...
      </p>
    </div>

    {/* SECTION 1 */}
    <section className="mb-16 scroll-mt-24" id="health-rules" >
      <div className="flex items-center gap-3 mb-6">
        <span className="flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 text-primary font-bold text-sm">1</span>
        <h2 className="text-2xl md:text-3xl font-bold text-[#1b140d] dark:text-white">
          Health Rules: Defining Meaningful Signals
        </h2>
      </div>

      {/* HEALTH RULE CARD */}
      <div className="rounded-xl border border-[#f3ede7] dark:border-white/10 bg-white dark:bg-white/5 shadow-sm overflow-hidden transition hover:shadow-lg">
        <div className="p-6 space-y-4">
          <div className="flex items-start gap-4 p-4 rounded-lg bg-gray-50 dark:bg-black/20">
            <MdWarning className="text-primary" />
            <div>
              <h4 className="font-bold text-sm mb-1">Condition Set A</h4>
              <div className="text-sm font-mono">Latency (p95) &gt; 3000ms</div>
            </div>
          </div>

          <div className="flex justify-center">
            <span className="px-3 py-1 text-xs font-bold text-gray-500">AND</span>
          </div>

          <div className="flex items-start gap-4 p-4 rounded-lg bg-gray-50 dark:bg-black/20">
            <MdErrorOutline className="text-red-500" />
            <div>
              <h4 className="font-bold text-sm mb-1">Condition Set B</h4>
              <div className="text-sm font-mono">Error Rate &gt; 5%</div>
            </div>
          </div>

          <div className="pt-4 border-t text-sm font-bold">
            THEN → Trigger Warning Alert
          </div>
        </div>
      </div>
    </section>

   {/* SECTION 2 - Notifications */}
<section className="mb-16 scroll-mt-24" id="alert-routing">
  <div className="flex items-center gap-3 mb-6">
    <span className="flex items-center justify-center w-8 h-8 rounded-full bg-primary/10 text-primary font-bold text-sm">
      2
    </span>

    <h2 className="text-2xl md:text-3xl font-bold text-text-main dark:text-white">
      Alert Configuration: Flexible Control & Routing
    </h2>
  </div>

  <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
    {["Email","SMS","Jira"].map((item)=>(
      <div
        key={item}
        className="group flex flex-col items-center gap-3 p-4 rounded-xl 
        border border-border-color dark:border-border-dark
        bg-surface-light dark:bg-surface-dark
        hover:border-primary/50 transition-colors"
      >
        <div className="w-12 h-12 rounded-full flex items-center justify-center 
        bg-gradient-to-br from-orange-100 to-orange-50 
        dark:from-orange-900/40 dark:to-orange-800/20
        group-hover:scale-110 transition-transform">
          <MdNotifications className="text-primary text-2xl" />
        </div>

        <span className="text-sm font-medium text-text-main dark:text-gray-200">
          {item}
        </span>
      </div>
    ))}
  </div>
</section>


   {/* SECTION 3 TABLE */}
<section className="mb-16 scroll-mt-24" id="alert-history">

  {/* Header */}
  <div className="flex items-start sm:items-center gap-3 mb-6">

    <span className="flex shrink-0 items-center justify-center w-8 h-8 rounded-full bg-primary/10 text-primary font-bold text-sm">
      3
    </span>

    <h2 className="text-2xl md:text-3xl font-bold text-[#1b140d] dark:text-white leading-tight">
      Alert History: Operational Transparency
    </h2>
  </div>

  {/* Table Container */}
  <div className="rounded-xl border border-[#f3ede7] dark:border-white/10 overflow-hidden bg-white dark:bg-black/10">

    {/* Horizontal scroll wrapper */}
    <div className="overflow-x-auto">

      <table className="w-full min-w-[640px] text-sm">

        {/* Table Head */}
        <thead className="bg-gray-50 dark:bg-black/20 text-xs uppercase whitespace-nowrap">

          <tr>
            <th className="px-4 md:px-6 py-4 text-left">
              Severity
            </th>

            <th className="px-4 md:px-6 py-4 text-left">
              Alert Name
            </th>

            <th className="px-4 md:px-6 py-4 text-left">
              Triggered At
            </th>

            <th className="px-4 md:px-6 py-4 text-left">
              Status
            </th>
          </tr>
        </thead>

        {/* Table Body */}
        <tbody className="divide-y divide-gray-100 dark:divide-white/10">

          {/* Row 1 */}
          <tr className="hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">

            <td className="px-4 md:px-6 py-4 whitespace-nowrap">
              <span className="text-red-600 font-bold">
                Critical
              </span>
            </td>

            <td className="px-4 md:px-6 py-4 font-medium text-[#1b140d] dark:text-white whitespace-nowrap">
              Checkout Service Latency
            </td>

            <td className="px-4 md:px-6 py-4 whitespace-nowrap text-gray-600 dark:text-gray-300">
              Oct 24, 10:42 AM
            </td>

            <td className="px-4 md:px-6 py-4 whitespace-nowrap">
              <span className="
                inline-flex items-center
                rounded-full
                bg-red-100 dark:bg-red-900/20
                text-red-700 dark:text-red-300
                px-2 py-1
                text-xs
                font-bold
              ">
                Active
              </span>
            </td>
          </tr>

          {/* Row 2 */}
          <tr className="hover:bg-gray-50 dark:hover:bg-white/5 transition-colors">

            <td className="px-4 md:px-6 py-4 whitespace-nowrap">
              <span className="text-orange-600 font-bold">
                Warning
              </span>
            </td>

            <td className="px-4 md:px-6 py-4 font-medium text-[#1b140d] dark:text-white whitespace-nowrap">
              High Memory Usage (Node-3)
            </td>

            <td className="px-4 md:px-6 py-4 whitespace-nowrap text-gray-600 dark:text-gray-300">
              Oct 24, 09:15 AM
            </td>

            <td className="px-4 md:px-6 py-4 whitespace-nowrap">
              <span className="
                inline-flex items-center
                rounded-full
                bg-green-100 dark:bg-green-900/20
                text-green-700 dark:text-green-300
                px-2 py-1
                text-xs
                font-bold
              ">
                Resolved
              </span>
            </td>
          </tr>

        </tbody>
      </table>
    </div>
  </div>
</section>

  </div>
);
}